export default "<div class=\"loadingGif\"></div>"